const PREFIX = '/portal';

/**
 * @deprecated 旧路由表仅保留兼容存量调用。
 *
 * 历史上 shared 路由需要先注入到业务层 SITE_ROUTER，避免丢失二级路径拼接逻辑；
 * 新增或迁移路由不再沿用该方式。
 *
 * 新增或迁移路由请使用 `SiteRouterKey + siteRouterManager`，
 * 不要在业务代码中继续直接读取 `SITE_ROUTER.xxx`。
 *
 * @see libs/shared/src/utils/site-router.ts
 */
export const SITE_ROUTER = {
    // 消息中心
    MESSAGE: `${PREFIX}/v1/message_center`,
    LOGINPAGE: {
        // 单租户自定义登录页
        LOGIN: `${PREFIX}/tenant/:tenantId/signin`
    },
    SSO: {
        // 发起认证请求
        ISS: `${PREFIX}/tenant/:tenantId/sso/:ssoType/iss`
    },
    ACCOUNT: {
        /** 账号设置页面 */
        INDEX: `${PREFIX}/account`,
        SWITCH_CORP: `${PREFIX}/account/switch_corp`,
        /** 账号注销页面 */
        CANCEL_VIEW: `${PREFIX}/account/cancel/view`,
        /** 第三方账号绑定页 */
        BIND_ISSUE: `${PREFIX}/account/provider/:type/bind_issue`
    },
    SUITE: {
        // 套件开启页
        HOME: `${PREFIX}/suite/:suiteId/home`
    },
    AUTHENTICATION: {
        // 跨域重定向
        SIGNIN_BRIDGE: `${PREFIX}/signin/bridge`,
        // 忘记密码页
        FORGOT_PASSWORD: `${PREFIX}/authn/forgot_password`,
        // 重置密码页
        RESET_PASSWORD: `${PREFIX}/authn/reset_password`,
        // 注册页
        REGISTER: `${PREFIX}/register`,
        // 登录页
        SIGNIN: `${PREFIX}/signin`,
        // 退出登录
        SIGNOUT: `${PREFIX}/signout`,
        // 登录重定向
        SIGNIN_LAUNCH: `${PREFIX}/signin/launch`,
        // 发起 谷歌 OAuth
        GOOGLE_ISSUE: `${PREFIX}/authn/provider/google/issue`,
        // fanruan通行证登录
        FANRUAN_ISSUE: `${PREFIX}/authn/provider/fanruan/issue`,
        // 微信服务号绑定逻辑
        WECHAT_SERVICE_BIND_CALLBACK: `${PREFIX}/authn/provider/wechat/service/bind_callback`,
        // 微信成员绑定页
        WECHAT_PLATFORM_BIND: `${PREFIX}/tenant/:tenantId/provider/wechat_platform/bind`,
        // 微信成员绑定回调
        WECHAT_PLATFORM_BIND_CALLBACK: `${PREFIX}/tenant/:tenantId/provider/wechat_platform/bind_callback`
    },
    CORP_COOP: {
        GUEST: {
            // 互联私有邀请确认页面
            IMPORT_VERIFY: `${PREFIX}/corp_coop/guest/import/verify`
        }
    },
    // 公开邀请链接页面
    CORP_JOIN: `${PREFIX}/corp/invitation/public`,
    MOBILE: {
        CONTACT: `${PREFIX}/tenant/:tenantId/admin_mobile`
    },
    ORDER: {
        CREATE: `${PREFIX}/tenant/:tenantId/admin/order/create`,
        PAY: `${PREFIX}/pay/pay_issue`,
        PAY_FINISH: `${PREFIX}/pay/pay_finish`
    },
    TENANT_VERIFY: {
        INDEX: `${PREFIX}/tenant/:tenantId/admin/verify`,
        CORP: `${PREFIX}/tenant/:tenantId/admin/verify?type=corp`,
        OWNER: `${PREFIX}/tenant/:tenantId/admin/verify?type=owner`,
        ID_CARD_SUCCESS_CALLBACK: `${PREFIX}/tenant/:tenantId/verify/id_card_success_callback`,
        ID_CARD_FAILED_CALLBACK: `${PREFIX}/tenant/:tenantId/verify/id_card_failed_callback`
    },
    WELCOME: `${PREFIX}/welcome`,
    PERSONA: `${PREFIX}/persona`,
    // 错误页面
    ERROR: `${PREFIX}/error/:errorType`,
    // 时区不兼容提示页面
    TZ_SUPPORT: `${PREFIX}/error/tz_support`,
    MICRO_BLANK: `${PREFIX}/error/micro-blank`,
    TECH_SUPPORT: `${PREFIX}/help/tech_support`
};
